<template>
    <router-link v-if="routeExists" :to="item.to" :title="item.label" :class="item.classes">
        <component
            :is="item.icon"
            v-if="options.showIcon"
            v-bind="{ fill: iconColor }"
            class="order-menu__icon"
        />
        <span v-if="options.showLabel" class="order-menu__label" v-text="item.label" />
    </router-link>
    <span v-else :title="item.label" :class="item.classes">
        <component
            :is="item.icon"
            v-if="options.showIcon"
            v-bind="{ fill: iconColor }"
            class="order-menu__icon"
        />
        <span v-if="options.showLabel" class="order-menu__label" v-text="item.label" />
    </span>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
        iconColor: {
            type: String,
            default: 'rgb(127, 127, 127)',
        },
    },
    computed: {
        options() {
            const { options = {}, label, icon } = this.item;
            const { showLabel = true, showIcon = false } = options;

            return {
                ...options,
                showLabel: showLabel && !!label,
                showIcon: showIcon && !!icon,
            };
        },
        // vue-router 4 throws when resolving a route name that doesn't exist
        routeExists() {
            return !!(
                this.item.to &&
                this.item.to.name &&
                this.$router.hasRoute(this.item.to.name)
            );
        },
    },
};
</script>
